import { createSelector } from '@reduxjs/toolkit';

import { selectAllAppointments } from 'FRONTEND/reducers/appointmentSlice';
import { selectAppointmentStatusFilterList, selectCalendarActorId } from 'FRONTEND/reducers/calendarSlice';
import { selectAllExperts } from 'FRONTEND/reducers/expertSlice';
import { selectAllResources } from 'FRONTEND/reducers/resourceSlice';
import { EXPERT, RESOURCE } from 'FRONTEND/utils/constants';

const selectStatusFilteredAppointments = createSelector(
  [selectAppointmentStatusFilterList, selectAllAppointments],
  (statusFilterList, appointmentList) => appointmentList.filter((appointment) => statusFilterList.some((statusFilter) => statusFilter.toLowerCase().includes(appointment.appointmentType.toLowerCase()))),
);
export const selectCalendarListedAppointments = createSelector(
  selectStatusFilteredAppointments,
  (appointmentList) => {
    return appointmentList.flatMap((appointment) => {
      const appointmentList = [{
        ...appointment,
        expertId: appointment.requester.id, // TODO: should we handle resourceId ?
      }];
      if (appointment.requiredMap) {
        appointmentList.push(...Object.values(appointment.requiredMap).map((requiredExpert) => ({
          ...appointment,
          expertId: requiredExpert.id, // TODO: should we handle resourceId ?
        })));
      }
      return appointmentList;
    });
  },
);

export const selectCalendarActor = createSelector(
  [selectCalendarActorId, selectAllResources, selectAllExperts, (state) => state.user],
  (actorId, resourceList, expertList, user) => {
    // an actor can be either an expert or a resource
    const expert = expertList.find((expert) => expert.id === actorId) || (user.id === actorId ? user : null);
    const resource = resourceList.find((resource) => resource.id === actorId);
    if (resource) {
      return { actorType: RESOURCE, ...resource };
    } else if (expert) {
      return { actorType: EXPERT, ...expert };
    } else {
      return null;
    }
  },
);
